import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./VerifyOTPResetPw.css";
import { New_ScrollX2025 } from "../../assets/icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { CgSpinner } from "react-icons/cg";

const VerifyOTPResetPw = (props) => {
  const {
    isOtpSuccess,
    setIsOtpSuccess,
    otp,
    setOpt,
    handleSubmitOtp,
    handleResendOtp,
    password,
    setPassword,
    confirmPassword,
    setconfirmPassword,
    inValid,
    submitSuccessLoading,
  } = props;

  const [showPassword, setShowPassword] = useState({ password: false, confirmPassword: false });

 const OTP_LENGTH = 6;
 // Ensure OTP is always an array of 6 characters
const otpArray = Array.from({ length: OTP_LENGTH }, (_, index) => otp[index] || "");

 // Handle OTP change
  const handleChange = (e, index) => {
  const value = e.target.value.replace(/\D/g, "").slice(-1);

  if (!value) return;

  const newOtp = [...otpArray];
  newOtp[index] = value;
  setOpt(newOtp.join(""));
  if (index < OTP_LENGTH - 1) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

 // Handle Backspace
  const handleKeyDown = (e, index) => {
    if (e.key !== "Backspace") return;

      const newOtp = [...otpArray];

    if (newOtp[index]) {
    // Clear current box only
      newOtp[index] = "";
      setOpt(newOtp.join(""));
    return;
  }

  // Current box empty -> move previous
      if (index > 0) {
      newOtp[index - 1] = "";
    setOpt(newOtp.join(""));
    document.getElementById(`otp-${index - 1}`)?.focus();
  }
};

  // Handle Paste
  const handlePaste = (e, index = 0) => {
    e.preventDefault();

    const pasted = e.clipboardData
    .getData("text")
    .replace(/\D/g, "");

    if (!pasted) return;

    const newOtp = [...otpArray];

    pasted
    .slice(0, OTP_LENGTH - index)
    .split("")
    .forEach((digit, i) => {
      newOtp[index + i] = digit;
    });

    setOpt(newOtp.join(""));

    const focusIndex = Math.min(
      index + pasted.length,
      OTP_LENGTH - 1
    );

    document.getElementById(`otp-${focusIndex}`)?.focus();
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  const handleShowPassword = (field) => {
  setShowPassword((prev) => ({
    ...prev,
    [field]: !prev[field],
  }));
};

  return (
    <>
      <ToastContainer closeButton={CloseButton} />

      <div
        className="VerifyOTPResetPw-Container"
        style={{ minHeight: "100vh", minHeight: "-webkit-fill-available" }}
      >
        <div className="vorpparticles" />

        <div className="vorpshell">
            {/* Topbar */}

            <header className="topbar">
                <nav className="w-full flex justify-between">
                    <a href="#" className="nav-logo">
                        <span className="nav-logo-icon"><img className="logo-img999 " src={New_ScrollX2025} alt="icon" /></span>              
                        <span>ScrollX</span>
                    </a>            
                    
                    <div className="top-actionslogin">
                        <span className=" sm:block">Remember your password?</span>
                        <Link to="/login">
                            <span className="text-white sm:block xl:text-[15px] manrope-300 ">Log In</span>
                        </Link>
                    </div>
                </nav>
            </header>

          {/* Main */}
          <main className="relative z-[2] flex-1 grid grid-cols-1 lg:grid-cols-[minmax(430px,.82fr)_minmax(540px,1.18fr)] min-h-[calc(100vh-58px)]">
            {/* Left - Form */}
            <section className="left-VerifyOTP flex items-center justify-center px-5 md:px-10 py-8 lg:border-r border-[rgba(255,255,255,.075)]">
              <div className="fade-up w-full max-w-[500px]">
                <p className="font-mono text-[11px] tracking-[.22em] uppercase text-[#c4b2ff] mb-[18px]">
                  Account recovery
                </p>
                <h1 className="text-[clamp(34px,3.15vw,46px)] leading-[1.02] tracking-[-0.045em] font-bold text-[#f0eeff] mb-2.5">
                  Reset your password
                </h1>
                <p className="text-[#9e9bc0] text-sm leading-relaxed mb-[18px]">
                  Enter the 6-digit code we sent to your email, then choose a
                  new password.
                </p>

                {/* Card */}
                <div className="bg-gradient-to-b from-[rgba(255,255,255,.045)] to-[rgba(255,255,255,.022)] border-[1px] border-[rgba(255,255,255,.075)] border-t-[rgba(255,255,255,.16)] rounded-[20px] p-[18px] shadow-[0_36px_80px_-42px_rgba(0,0,0,.9)]">
                  {/* OTP */}
                  <div className="mb-4">
                    <label className="block font-mono text-[12px] tracking-[.16em] uppercase text-[#5a577a] mb-[7px]">
                      One-time code
                    </label>
                    <div className="flex gap-2">
                      {otpArray.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-${index}`}
                          type="tel"
                          maxLength="1"
                          value={digit}
                          onChange={(e) => handleChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          autoComplete="one-time-code"
                          onPaste={(e) => handlePaste(e, index)}
                          inputMode="numeric"
                          placeholder=""
                          className="w-full h-12 text-center text-lg font-mono border-[1px] border-[rgba(255,255,255,.095)] bg-[rgba(255,255,255,.045)] text-[#f0eeff] rounded-[10px] outline-none focus:border-[rgba(124,92,255,.58)] focus:bg-[rgba(255,255,255,.06)] focus:shadow-[0_0_0_4px_rgba(124,92,255,.1)] transition-all"
                        />
                      ))}
                    </div>
                    {inValid && (
                      <p className="text-red-400 text-sm mt-2">{inValid}</p>
                    )}
                  </div>

                  {/* New password */}
                  <div className="mb-4">
                    <label
                      htmlFor="newPassword"
                      className="block font-mono text-[12px] tracking-[.16em] uppercase text-[#5a577a] mb-[7px]"
                    >
                      New password
                    </label>
                    <div className="relative">
                      <input
                        id="newPassword"
                         type={showPassword.password ? "text" : "password"}
                        placeholder="At least 8 characters"
                        autoComplete="new-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full h-[41px] border-[1px] border-[rgba(255,255,255,.095)] bg-[rgba(255,255,255,.045)] text-[#f0eeff] rounded-[10px] px-3.5 pr-10 text-sm outline-none focus:border-[rgba(124,92,255,.58)] focus:bg-[rgba(255,255,255,.06)] focus:shadow-[0_0_0_4px_rgba(124,92,255,.1)] transition-all placeholder:text-[rgba(168,164,200,.48)]"
                      />
                      <button
                        type="button"
                        onClick={() => handleShowPassword("password")}
                        aria-label="Show password"
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5a577a] hover:text-[#9e9bc0] transition-colors"
                      >
                        {showPassword.password ? <FaEye /> : <FaEyeSlash />}
                      </button>
                    </div>
                  </div>

                  {/* Confirm password */}
                  <div className="mb-6">
                    <label
                      htmlFor="confirmPassword"
                      className="block font-mono text-[12px] tracking-[.16em] uppercase text-[#5a577a] mb-[7px]"
                    >
                      Confirm new password
                    </label>
                    <div className="relative">
                      <input
                        id="confirmPassword"
                        type={showPassword.confirmPassword ? "text" : "password"}
                        placeholder="Re-enter your password"
                        autoComplete="new-password"
                        value={confirmPassword}
                        onChange={(e) => setconfirmPassword(e.target.value)}
                        className="w-full h-[41px] border-[1px] border-[rgba(255,255,255,.095)] bg-[rgba(255,255,255,.045)] text-[#f0eeff] rounded-[10px] px-3.5 pr-10 text-sm outline-none focus:border-[rgba(124,92,255,.58)] focus:bg-[rgba(255,255,255,.06)] focus:shadow-[0_0_0_4px_rgba(124,92,255,.1)] transition-all placeholder:text-[rgba(168,164,200,.48)]"
                      />
                      <button
                        type="button"
                        onClick={() => handleShowPassword("confirmPassword")}
                        aria-label="Show password"
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5a577a] hover:text-[#9e9bc0] transition-colors"
                      >
                        {showPassword.confirmPassword  ? <FaEye /> : <FaEyeSlash />}
                      </button>
                    </div>
                    <p
                      className="text-[#ff8a80] text-xs mt-2"
                      id="matchError"
                      hidden
                    >
                      Passwords don't match.
                    </p>
                  </div>

                  {/* Actions */}
                  <div className="flex items-center gap-3">
                    <button
                      type="button"
                      id="resendBtn"
                      onClick={handleResendOtp}
                      className="w-1/3 h-11 border-[1px] border-[rgba(255,255,255,.11)] bg-[rgba(255,255,255,.055)] text-[#f0eeff] rounded-xl text-sm font-medium hover:border-[rgba(255,255,255,.2)] hover:bg-[rgba(255,255,255,.08)] transition-all"
                    >
                      Resend code
                    </button>
                    <button
                      type="submit"
                      id="confirmBtn"
                      onClick={handleSubmitOtp}
                      className="flex-1 h-11 bg-[#7c5cff] text-white rounded-xl text-[15px] font-semibold flex items-center justify-center gap-2 hover:bg-[#9d7dff] hover:-translate-y-px hover:shadow-[0_14px_38px_rgba(124,92,255,.32)] transition-all"
                    >
                      Confirm <span>→</span>
                      {submitSuccessLoading && (
                        <CgSpinner className="animate-spin text-[1.1rem]" />
                      )}
                    </button>
                  </div>

                  {/* Success */}
                  <div className="auth-success" id="successMsg">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Password updated. You can now log in.
                  </div>
                </div>
              </div>
            </section>

            {/* Right - Value prop */}
            <section className="right-VerifyOTP hidden lg:flex items-center justify-center px-10 py-8 relative overflow-hidden">
              <div className="absolute inset-10 border-[1px] border-[rgba(255,255,255,.055)] rounded-[30px] bg-gradient-to-br from-[rgba(18,16,30,.55)] to-[rgba(18,16,30,.16)] pointer-events-none" />
              <div className="fade-up-delayed relative z-[2] w-full max-w-[650px]">
                <div className="border-[1px] border-[rgba(124,92,255,.22)] border-t-[rgba(196,178,255,.26)] bg-[radial-gradient(circle_at_20%_0%,rgba(124,92,255,.16),transparent_44%),linear-gradient(135deg,rgba(18,16,30,.9),rgba(11,9,20,.8))] rounded-3xl p-6 shadow-[0_34px_90px_-48px_rgba(124,92,255,.48)]">
                  <h2 className="text-[clamp(26px,3vw,38px)] leading-[1.08] tracking-[-0.04em] font-bold text-[#f0eeff] mb-[18px]">
                    Your credits, fonts, and style are
                    <br />
                    <em className="not-italic text-[#c4b2ff] font-normal">
                      exactly where you left them.
                    </em>
                  </h2>
                  <p className="text-[#9e9bc0] text-[14px] leading-relaxed mb-[24px]">
                    Reset your password and get back to rendering
                    broadcast-ready end credits in minutes.
                  </p>

                  {/* Preview mock */}
                  <div className="border-[1px] border-[rgba(255,255,255,.075)] bg-[#070610] rounded-[18px] overflow-hidden">
                    {/* Titlebar */}
                    <div className="h-[38px] flex items-center justify-between border-b-[1px] border-[rgba(255,255,255,.06)] px-3.5">
                      <div className="flex gap-[7px]">
                        <div className="w-[11px] h-[11px] rounded-full bg-[#ff5f57]" />
                        <div className="w-[11px] h-[11px] rounded-full bg-[#febc2e]" />
                        <div className="w-[11px] h-[11px] rounded-full bg-[#28c840]" />
                      </div>
                      <div className="flex items-center gap-[5px] text-[#f0eeff] bg-[rgba(255,255,255,.06)] border-[1px] border-[rgba(255,255,255,.1)] rounded-[6px] px-3 py-1 font-mono text-[11px]">
                        <svg
                          width="10"
                          height="10"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                        >
                          <path d="M1 4v6h6M23 20v-6h-6" />
                          <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14l-4.64 4.36A9 9 0 0 1 3.51 15" />
                        </svg>
                        Synced
                      </div>
                    </div>

                    {/* Meta bar */}
                    <div className="px-4 py-2.5 border-b-[1px] border-[rgba(255,255,255,.06)] flex items-center justify-between">
                      <span className="font-mono text-[10px] tracking-[.12em] uppercase text-[#5a577a]">
                        Live Preview
                      </span>
                      <div className="flex gap-2 items-center">
                        <span className="font-mono text-[10px] text-[#5a577a]">
                          00:01:42.08
                        </span>
                        <span className="font-mono text-[10px] text-[#c4b2ff] bg-[rgba(124,92,255,.15)] border-[1px] border-[rgba(124,92,255,.2)] px-2 py-px rounded">
                          4K
                        </span>
                      </div>
                    </div>

                    {/* Credits */}
                    <div className="flex flex-col items-center justify-center p-12 min-h-[260px] bg-[#07060e]">
                      {[
                        { role: "Directed by", name: "AVA MORGAN" },
                        { role: "Produced by", name: "ETHAN BROOKS" },
                        { role: "Edited by", name: "JAMIE M." },
                        { role: "Music by", name: "MAYA PATEL" },
                      ].map((credit, i) => (
                        <div key={i} className="mb-4 text-center last:mb-0">
                          <span className="block font-mono text-[9px] tracking-[.18em] uppercase text-[#5a577a] mb-[3px]">
                            {credit.role}
                          </span>
                          <span className="block text-[15px] tracking-[.05em] text-[#f0eeff]">
                            {credit.name}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
};

export default VerifyOTPResetPw;
